/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PrivateDisabilityInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import RadioInput from '../Fields/RadioInput';
import TextInput from '../Fields/TextInput';
import Section from '../Section';
import { getClientPicklistValue, shouldMakeNotesFieldReadOnly } from './Helpers/ClientPicklist';
import SelectInput from '../Fields/SelectInput';

const disabilityType = [
  {
    id: 'any',
    text: 'Any Occupation',
  },
  {
    id: 'own',
    text: 'Own Occupation',
  },
];

class DisabilityInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      privateDisabilityInsuranceCompany: '',
      privateDisabilityInsuranceInsuredClientId: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { insuredClientOptions } = this.props;
    const {
      privateDisabilityInsuranceCompany,
      privateDisabilityInsuranceInsuredClientId,
    } = this.state;
    const nameList = [];
    if (privateDisabilityInsuranceInsuredClientId) nameList.push(getClientPicklistValue(insuredClientOptions, privateDisabilityInsuranceInsuredClientId));
    if (privateDisabilityInsuranceCompany) nameList.push(privateDisabilityInsuranceCompany);
    return `${nameList.join(' - ') || 'New policy'} (Private)`;
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: {
        id, insuredClientOptions, children: removeButton, expanded,
      },
      state: { privateDisabilityInsuranceInsuredClientId },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          placeholder="Insurance company"
          name={`privateDisabilityInsuranceCompany.${id}`}
          answerKey="privateDisabilityInsuranceCompany"
          onChange={(name, value) => onChange('privateDisabilityInsuranceCompany', value)
          }
        />
        <CurrencyInput
          placeholder="Monthly benefit"
          name={`privateDisabilityInsuranceBenefit.${id}`}
          answerKey="privateDisabilityInsuranceBenefit"
        />
        <TextInput
          placeholder="Benefit period"
          name={`privateDisabilityInsurancePeriod.${id}`}
          answerKey="privateDisabilityInsurancePeriod"
        />
        <CurrencyInput
          placeholder="Annual premium"
          name={`privateDisabilityInsurancePremium.${id}`}
          answerKey="privateDisabilityInsurancePremium"
        />
        <SelectInput
          label="Who is insured?"
          name={`privateDisabilityInsuranceInsuredClientId.${id}`}
          options={insuredClientOptions}
          answerKey="privateDisabilityInsuranceInsuredClientId"
          onChange={(name, value) => onChange('privateDisabilityInsuranceInsuredClientId', value)}
        />
        <TextInput
          placeholder="Insured Notes"
          name={`privateDisabilityInsuranceInsuredNotes.${id}`}
          answerKey="privateDisabilityInsuranceInsuredNotes"
          onChange={(name, value) => onChange('privateDisabilityInsuranceInsuredNotes', value)}
          readOnly={shouldMakeNotesFieldReadOnly(privateDisabilityInsuranceInsuredClientId)}
        />
        <RadioInput
          label="Definition of Disability"
          name={`privateDisabilityInsuranceDefinition.${id}`}
          answerKey="privateDisabilityInsuranceDefinition"
          options={disabilityType}
        />
        <BoolInput
          label="Is there a future increase option?"
          name={`privateDisabilityInsuranceCanIncrease.${id}`}
          answerKey="privateDisabilityInsuranceCanIncrease"
          checkedChildren={
            <CurrencyInput
              placeholder="Maximum increase option"
              name={`privateDisabilityInsuranceMaximumIncrease.${id}`}
              answerKey="privateDisabilityInsuranceMaximumIncrease"
            />
          }
        />
      </LabeledVerticalExpander>
    );
  }
}

DisabilityInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  insuredClientOptions: PropTypes.array.isRequired,
};

DisabilityInsuranceList.defaultProps = {
  expanded: false,
};

const DisabilityInsurance = ({ insuredClientOptions }) => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      height={400}
      title="Disability Insurance (Private / Non-Group)"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - disability"
        addLabel="Add a policy"
        keyPrefix="privateDisabilityInsurances"
        Of={DisabilityInsuranceList}
        childProps={{ insuredClientOptions }}
      />
    </Section>
  );
};

DisabilityInsurance.propTypes = {
  insuredClientOptions: PropTypes.array.isRequired,
};

export default DisabilityInsurance;
